import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box
} from '@mui/material';

export default function RecipientSelector({ value, onChange }) {
  const recipientTypes = [
    {
      value: 'all',
      label: 'All Contacts',
      description: 'Send to all customers, vendors, and leads'
    },
    {
      value: 'customers',
      label: 'Customers Only',
      description: 'Previous buyers and registered customers'
    },
    {
      value: 'vendors',
      label: 'Vendors/Consignors',
      description: 'Estate sale vendors and consignment partners'
    },
    {
      value: 'leads',
      label: 'Leads',
      description: 'Prospects and inquiries'
    }
  ];

  const selectedType = recipientTypes.find(t => t.value === value);

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel>Recipients</InputLabel>
        <Select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          label="Recipients"
        >
          {recipientTypes.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {selectedType && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          {selectedType.description}
        </Typography>
      )}
    </Box>
  );
}
